/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioCreateDto } from '../../models/portfolio-create-dto';
import { PortfolioDto } from '../../models/portfolio-dto';

export interface PortfolioAdminControllerCreateV1$Params {
      body: PortfolioCreateDto
}

export function portfolioAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: PortfolioAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
  const rb = new RequestBuilder(rootUrl, portfolioAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PortfolioDto>;
    })
  );
}

portfolioAdminControllerCreateV1.PATH = '/api/v1/portfolios/admin';
